import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnergyStorageSystem, Pvmodule } from '@intellio/shared/models';
import { AppConfigService } from './app-config.service';
import { AuthService } from './auth.service';
import { BaseService } from './base-service.service';

@Injectable({
  providedIn: 'root',
})
export class EnergyStorageSystemsService extends BaseService {
  constructor(
    protected client: HttpClient,
    protected configService: AppConfigService,
    protected authService: AuthService
  ) {
    super(client, configService, authService);
  }

  getESS() {
    const url = '/api/energystoragesystem';
    return this.get<EnergyStorageSystem[]>(url);
  }
}
